import styles from "./index.module.scss";
import { Badge } from "react-bootstrap";
import CustomAnimatedNumber from "../CustomAnimatedNumber";

const Pin = ({
  topCaption = "",
  leftSideText = "",
  rightSideText = "",
  onClick,
  width = 109,
  isAnimatedNumber = true,
  smallFont = false,
  rightWidth = 40,
}) => {
  return (
    <div
      className={styles.parent}
      style={{ width: width, pointerEvents: onClick ? "auto" : "none" }}
    >
      <span className={styles.caption}>{topCaption}</span>
      <Badge
        className={`${styles.lightTextBadge} ${styles.badge} ${
          styles.hoverable
        } ${styles.left} ${smallFont ? styles.smallFont : null}`}
        bg="white"
        onClick={onClick}
      >
        <div>{leftSideText}</div>
        <div className={styles.rightSide} style={{ width: rightWidth }}>
          {isAnimatedNumber ? (
            <CustomAnimatedNumber delay={500} value={rightSideText} />
          ) : (
            rightSideText
          )}
        </div>
      </Badge>
    </div>
  );
};

export default Pin;
